import { makeStyles } from '@material-ui/core';

import { colorTheme, red } from '../../shared/styles/colors';

import type { RTStatus } from '../../business/shared/domain';

export default makeStyles({
  chip: ({ rtStatus, hasTurboUrgency }: Props) => ({
    borderRadius: '0.25rem',
    height: 'inherit',
    padding: '0.25rem 0.5rem',
    color: hasTurboUrgency ? red[10] : colorTheme.rtStatus[rtStatus].text,
    backgroundColor: hasTurboUrgency
      ? red[60]
      : colorTheme.rtStatus[rtStatus].bg,
  }),
  label: {
    padding: 0,
    fontWeight: 600,
    fontSize: '0.625rem',
    lineHeight: '1.125rem',
  },
  container: {
    fontFamily: 'PP Object Sans',
  },
});

interface Props {
  rtStatus: RTStatus;
  hasTurboUrgency: boolean;
}
